var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSup8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 679.427,
    height: 468.969,
    viewBox: "0 0 679.427 468.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#666af6;}.a,.f,.r{opacity:0.1;}.b{fill:#30374e;}.d{fill:#444053;}.e{fill:#fff;opacity:0.2;}.g{fill:#44bba4;}.h{fill:#afc0e0;}.i{fill:#e3e8f4;}.j{fill:none;stroke:#535461;stroke-miterlimit:10;stroke-width:2px;}.k{opacity:0.25;}.l{fill:url(#a);}.m,.n{fill:#31446c;}.n,.p{opacity:0.05;}.o{fill:#565387;}.q{fill:#ee8e9e;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.938,342.519c12.009-19.616,39.167-16.2,58.425-5.957s38.476,25.525,59.67,22.589c17.871-2.478,32.525-18.061,40.441-36.039s10.24-38.249,12.468-58.1q4.2-37.415,8.393-74.878c1.025-9.132,2.234-18.77,7.369-26,6.785-9.531,19.223-12.462,29.862-9.6s19.711,10.55,27.473,19.122c24.864,27.449,38.952,64.555,60.689,95.1,4.426,6.219,9.424,12.367,16.036,15.369,9.531,4.319,20.474,1.263,29.784-3.544,30.38-15.661,50.789-47.619,70.845-77.44,9.757-14.493,21.653-29.993,37.886-31.572,17.078-1.7,31.905,12.855,41.943,28.266,32.215,49.585,39.119,117.279,78.035,160.526,4.831,5.361,10.162,10.317,16.3,13.647a42.086,42.086,0,0,0,6.314,2.77c33.954,11.753,45.272,58.932,20.158,86.905-.542.6-1.1,1.191-1.656,1.787-3.729,3.938-7.952,7.661-12.992,8.834-4.688,1.084-9.531-.167-14.177-1.519-29.7-8.667-59.045-21.915-89.753-21.272-29.88.6-58.223,14.4-87.769,19.366-19.866,3.342-40.078,2.675-60.165,1.954q-100.35-3.61-200.658-8.4c-33.192-1.525-66.4-2.978-99.581-4.676-25.567-1.328-41.853-4.253-44.82-33.925C42.867,399.854,19.539,367.681,34.938,342.519Z",
    transform: "translate(-29.72 -95.629)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 160.83,
    cy: 22.475,
    rx: 160.83,
    ry: 22.475,
    transform: "translate(309.705 424.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M178.46,642.933s7.863-1.787,13.016,3.5c0,0-3.312,2.978-11.1-.322Z",
    transform: "translate(-89.857 -293.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M175.178,643s-4.658,6.6-1.7,13.373c0,0,4.027-1.936,3.914-10.395Z",
    transform: "translate(-87.445 -293.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M168.2,624.706s2.794-6.046,16.084,1.263c0,0-1.43,4.039-7.077,4.1S169.868,627.678,168.2,624.706Z",
    transform: "translate(-85.709 -285.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M162.508,625.68s-6.654-.31-6.279,14.845c0,0,4.247.6,6.9-4.4S164.373,628.557,162.508,625.68Z",
    transform: "translate(-80.863 -286.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M159,601.685s2.978-10.532,16.959-4.1c0,0-2.442,9.644-15.369,7.529Z",
    transform: "translate(-81.99 -274.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M150.29,576.808s6.3-10.865,19.354-2.049c0,0-3.687,10.049-18.043,5.689Z",
    transform: "translate(-78.468 -264.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M146.15,552.8s7.524-10.1,20.468-1.376c0,0-7.184,8.9-20.307,3.812Z",
    transform: "translate(-76.794 -255.084)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M142.41,528.833s7.6-10.52,20.009-1.876c0,0-8.745,9.43-19.854,4.211Z",
    transform: "translate(-75.282 -245.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M142.23,505.741s7.833-13.421,19.449-5.462c0,0-8.59,11.658-19.282,7.9Z",
    transform: "translate(-75.209 -234.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M144,481.134s8.34-13.343,19.711-4.277c0,0-10.186,11.765-19.58,6.642Z",
    transform: "translate(-75.925 -225.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M147.448,457.348s10.127-12.694,19.985-8.56c0,0-10.532,13.463-20.253,11.771Z",
    transform: "translate(-77.211 -214.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M152.141,434.259s11.64-15.488,19.282-11.092c0,0-8.524,11.967-20,13.909Z",
    transform: "translate(-78.925 -204.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M159.4,410.2s10.228-12.7,18.466-10.27c0,0-8.608,13.04-19.717,14.106Z",
    transform: "translate(-81.646 -195.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M166.853,386.761s11.425-12.271,16.864-10.615c0,0-7.952,13.32-17.227,13.195Z",
    transform: "translate(-85.018 -185.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M173.87,363.195s9.585-14.386,15.381-13.7c0,0-5.546,12.623-15.285,15.089Z",
    transform: "translate(-88.002 -174.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M180.755,335.845s8.572-11.116,13.588-11.425c0,0-6.38,14.5-13.743,14.892Z",
    transform: "translate(-90.723 -164.739)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M184.286,309.152,191.78,286.7s1.787,19.717-8.34,26.58Z",
    transform: "translate(-91.871 -149.489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M187.712,270.119s.262-18.341-.792-19.759c0,0,7.428,14.737,1.275,27.825Z",
    transform: "translate(-93.278 -134.796)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M148.345,604.911s-9.686-5.135-14.755,9.37c0,0,8.638,4.932,16.084-5.844Z",
    transform: "translate(-71.716 -277.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M138.662,579.177s-11.747-4.438-16.292,10.651c0,0,9.215,5.451,17.579-7.005Z",
    transform: "translate(-67.18 -267.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M131.468,555.214s-8.81-9-20.468,1.388c0,0,8.3,7.857,20.629,1.066Z",
    transform: "translate(-62.583 -256.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M128.311,529.775s-8.935-9.418-20.081.81c0,0,9.924,8.179,20.253,1.519Z",
    transform: "translate(-61.463 -246.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M129.4,505.7s-6.767-13.981-18.961-6.952c0,0,7.661,12.289,18.609,9.376Z",
    transform: "translate(-62.356 -234.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M132.208,479.994s-6.749-14.237-19.1-6.594c0,0,8.733,12.873,18.669,8.894Z",
    transform: "translate(-63.436 -224.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M140.178,452.432s-3.36-15.875-14.029-16.6c0,0,3.384,16.757,12.813,19.586Z",
    transform: "translate(-68.708 -209.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M145.626,429.216s-2.186-19.247-11-19.336c0,0,1.281,14.636,10.192,22.13Z",
    transform: "translate(-72.137 -199.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M153.444,404.625s-3.7-15.881-12.194-17.275c0,0,2.085,15.488,11.634,21.278Z",
    transform: "translate(-74.813 -190.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M164.173,381.366s-1.191-16.721-6.493-18.836c0,0-2.15,15.357,5.153,21.076Z",
    transform: "translate(-81.336 -180.148)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M169.51,359.093s-1.876-17.186-7.333-19.253c0,0-.894,13.754,6.612,20.432Z",
    transform: "translate(-83.261 -170.974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M178.458,334.253s-.977-14-4.974-17.043c0,0-2.728,15.6,3.187,19.991Z",
    transform: "translate(-87.592 -161.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M179.952,307.617,174.71,284.54s-3.711,19.443,5.7,27.271Z",
    transform: "translate(-88.05 -148.616)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M175.558,272.87s-10.5-15.059-10.419-16.81c0,0,2.109,16.37,14.541,23.762Z",
    transform: "translate(-84.472 -137.101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M174.123,260.622s-10.4-21.677-14.553-23.232c0,0,13.159,5.617,15.256,22.517Z",
    transform: "translate(-82.22 -129.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M180.136,319.032l-.6-.149c5.868-25.019,6.7-40.793,2.323-44.415l.405-.488C186.879,277.816,186.152,293.4,180.136,319.032Z",
    transform: "translate(-90.294 -144.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M151.633,407.119l-.923-.256c.649-2.3,1.352-4.64,2.1-6.946,6.553-20.087,12-38.72,15.339-52.981l.757-.447c-3.348,14.3-8.643,33.615-15.184,53.719C152.98,402.509,152.277,404.832,151.633,407.119Z",
    transform: "translate(-78.638 -173.663)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M175.576,580.524c-.131-.125-13.236-13.028-23.3-35.884a138.42,138.42,0,0,1-11.086-42.157c-1.787-18.186.655-38.8,5.957-57.722l.762.786c-11.914,42.479-3.687,77.642,5.5,98.527,9.966,22.636,22.922,35.414,23.053,35.539Z",
    transform: "translate(-74.553 -213.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M223.53,558.339s4.766-1.09,7.875,2.115c0,0-2.007,1.787-6.713-.2Z",
    transform: "translate(-108.08 -259.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M221.561,558.39s-2.812,3.991-1.025,8.083c0,0,2.43-1.191,2.383-6.284Z",
    transform: "translate(-106.629 -259.336)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M217.34,547.318s1.686-3.652,9.71.768c0,0-.864,2.436-4.277,2.472S218.359,549.117,217.34,547.318Z",
    transform: "translate(-105.577 -254.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M213.894,547.91s-4.027-.185-3.8,8.971c0,0,2.567.357,4.17-2.657S215.02,549.649,213.894,547.91Z",
    transform: "translate(-102.644 -255.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M211.75,533.4s1.829-6.368,10.264-2.49c0,0-1.471,5.832-9.287,4.551Z",
    transform: "translate(-103.317 -247.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M206.51,518.369s3.806-6.553,11.7-1.239c0,0-2.234,6.076-10.907,3.437Z",
    transform: "translate(-101.198 -241.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M204,503.848s4.551-6.106,12.372-.834c0,0-4.337,5.361-12.271,2.305Z",
    transform: "translate(-100.184 -236.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M201.74,489.361s4.6-6.362,12.1-1.132c0,0-5.284,5.7-12,2.544Z",
    transform: "translate(-99.27 -230.135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M201.64,475.4s4.766-8.107,11.753-3.3c0,0-5.194,7.047-11.658,4.766Z",
    transform: "translate(-99.229 -223.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M202.68,460.522s5.057-8.072,11.914-2.609c0,0-6.159,7.112-11.842,4.015Z",
    transform: "translate(-99.65 -217.945)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M204.8,446.15s6.118-7.672,12.081-5.171c0,0-6.368,8.137-12.23,7.113Z",
    transform: "translate(-100.446 -211.663)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M207.625,432.187s7.035-9.358,11.658-6.707c0,0-5.153,7.238-12.092,8.411Z",
    transform: "translate(-101.473 -205.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M212.029,417.66s6.183-7.678,11.175-6.207c0,0-5.2,7.881-11.914,8.524Z",
    transform: "translate(-103.131 -199.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M216.52,403.473s6.9-7.416,10.192-6.416c0,0-4.8,8.048-10.413,7.976Z",
    transform: "translate(-105.157 -194.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M220.76,389.223s5.8-8.7,9.3-8.292c0,0-3.348,7.631-9.239,9.126Z",
    transform: "translate(-106.96 -187.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M224.935,372.69s5.182-6.719,8.215-6.91c0,0-3.86,8.769-8.31,8.989Z",
    transform: "translate(-108.609 -181.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M227.046,356.558,231.567,343s1.072,11.914-5.057,16.084Z",
    transform: "translate(-109.285 -172.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M229.133,332.954s.155-11.086-.483-11.944c0,0,4.492,8.906.768,16.822Z",
    transform: "translate(-110.15 -163.361)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M205.315,535.357s-5.85-3.109-8.935,5.659c0,0,5.224,2.979,9.728-3.526Z",
    transform: "translate(-97.103 -249.807)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M199.483,519.751s-7.107-2.681-9.853,6.439c0,0,5.57,3.294,10.627-4.229Z",
    transform: "translate(-94.374 -243.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M195.122,505.305s-5.32-5.439-12.372.834c0,0,5.022,4.766,12.474.643Z",
    transform: "translate(-91.592 -236.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M193.22,489.929s-5.4-5.689-12.14.494c0,0,6,4.938,12.235.917Z",
    transform: "translate(-90.917 -230.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M193.877,475.335s-4.092-8.453-11.467-4.206c0,0,4.634,7.428,11.253,5.671Z",
    transform: "translate(-91.454 -223.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M195.562,459.819s-4.08-8.608-11.562-3.985c0,0,5.278,7.786,11.288,5.361Z",
    transform: "translate(-92.097 -217.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M200.393,443.187s-2.031-9.6-8.483-10.037c0,0,2.043,10.127,7.744,11.836Z",
    transform: "translate(-95.295 -208.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M203.672,429.133S202.361,417.5,197,417.44c0,0,.774,8.852,6.159,13.385Z",
    transform: "translate(-97.353 -202.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M208.409,414.268s-2.234-9.6-7.369-10.448c0,0,1.263,9.358,7.035,12.861Z",
    transform: "translate(-98.987 -196.842)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M214.9,400.21s-.733-10.127-3.92-11.39c0,0-1.3,9.287,3.109,12.742Z",
    transform: "translate(-102.932 -190.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M218.128,386.74S217,376.351,213.7,375.1c0,0-.542,8.34,4,12.355Z",
    transform: "translate(-104.096 -185.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M223.55,371.725s-.6-8.465-2.978-10.305c0,0-1.65,9.436,1.924,12.087Z",
    transform: "translate(-106.73 -179.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M224.462,355.621l-3.169-13.951s-2.246,11.759,3.443,16.489Z",
    transform: "translate(-106.999 -171.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M221.786,334.622s-6.344-9.1-6.3-10.162c0,0,1.269,9.894,8.786,14.362Z",
    transform: "translate(-104.829 -164.756)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M220.888,327.219s-6.29-13.105-8.8-14.029a17.1,17.1,0,0,1,9.221,13.617Z",
    transform: "translate(-103.454 -160.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M224.535,362.515l-.375-.089c3.574-15.125,4.051-24.662,1.406-26.848l.244-.3C228.616,337.6,228.175,347.027,224.535,362.515Z",
    transform: "translate(-108.334 -169.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M207.32,415.795l-.56-.161c.393-1.388.822-2.8,1.275-4.17,3.949-12.146,7.25-23.411,9.269-32.03l.459-.274c-2.025,8.638-5.224,20.325-9.18,32.483C208.13,413.019,207.707,414.407,207.32,415.795Z",
    transform: "translate(-101.299 -186.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M221.789,520.61c-.077-.077-8-7.875-14.088-21.7a83.824,83.824,0,0,1-6.7-25.484c-1.09-11,.4-23.458,3.61-34.9l.459.477c-7.2,25.68-2.228,46.94,3.324,59.569,6.028,13.7,13.856,21.4,13.939,21.481Z",
    transform: "translate(-98.827 -210.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M223.253,567.74a22.777,22.777,0,0,0-4.468,1.275c-32.132,12.831-31.6,96.823-31.6,96.823h-9.46s-2.978-36.045-15.959-87.471c-11.693-46.267,36.266-87.733,46.005-95.6,1.1-.876,1.7-1.34,1.7-1.34C257.785,499.182,223.253,567.74,223.253,567.74Z",
    transform: "translate(-82.372 -228.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M213.015,482.9c-1.114-.512-2.264-1-3.485-1.448,0,0-.6.465-1.7,1.34-9.74,7.863-57.7,49.329-46.005,95.6,12.98,51.426,15.929,87.459,15.929,87.459h5.32s-2.949-36.045-15.959-87.471C155.466,532.322,202.96,491.011,213.015,482.9Z",
    transform: "translate(-82.393 -228.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M483.91,578.379C470.9,629.8,467.97,665.838,467.97,665.838h-9.477s.6-87.781-33.794-97.58a18.788,18.788,0,0,0-2.27-.53s-34.55-68.558,13.772-86.3c0,0,.488.363,1.37,1.072C446.525,489.668,495.735,531.575,483.91,578.379Z",
    transform: "translate(-183.659 -228.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M255.716,567.748a22.773,22.773,0,0,0-4.468,1.275,583.313,583.313,0,0,1-11.008-86.232c1.1-.876,1.7-1.34,1.7-1.34C290.248,499.19,255.716,567.748,255.716,567.748Z",
    transform: "translate(-114.836 -228.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M437.6,482.538a536.712,536.712,0,0,1-12.873,85.779,18.779,18.779,0,0,0-2.27-.53s-34.55-68.558,13.772-86.3C436.214,481.465,436.7,481.829,437.6,482.538Z",
    transform: "translate(-183.671 -228.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M351.805,408.877q-5,19.741-11.729,40.507s-21.278,22.166-72.674,0c0,0-5.135-14.475-10.782-39.083-12.432-54.107-27.342-157.214,4.426-263.122A394.2,394.2,0,0,1,301.065,56.36s27.14,31.161,47.06,90.8S380.72,294.934,351.805,408.877Z",
    transform: "translate(-115.561 -56.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 42.669,
    cy: 42.669,
    r: 42.669,
    transform: "translate(147.153 132.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M358.106,329.465a30.261,30.261,0,0,1-49.442,23.4,30.578,30.578,0,0,1-5.671-6.153,29.784,29.784,0,0,1-1.954-3.211,30.2,30.2,0,0,1-3.449-14.04v-.721a30.3,30.3,0,0,1,22.041-28.426,31.291,31.291,0,0,1,7.291-1.108h.905A30.261,30.261,0,0,1,358.106,329.465Z",
    transform: "translate(-138.023 -154.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M361,147.161c-48.412,23.178-87.1,0-87.1,0a394.2,394.2,0,0,1,40.048-90.8S341.088,87.521,361,147.161Z",
    transform: "translate(-128.445 -56.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M361.689,648.14q-3.4,13.367-7.565,27.193-1.978,6.594-4.17,13.3s-21.278,22.166-72.674,0c0,0-1.668-4.7-4.17-13.3-1.87-6.493-4.2-15.2-6.63-25.787,0,0,19.134,8.167,46.291,8.167a127.541,127.541,0,0,0,48.918-9.573Z",
    transform: "translate(-125.445 -295.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M358.624,693.79q-1.978,6.594-4.17,13.3s-21.278,22.166-72.674,0c0,0-1.668-4.7-4.17-13.3C277.6,693.79,329.989,708.861,358.624,693.79Z",
    transform: "translate(-129.945 -314.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M319.656,300.248l-.066.048L297.61,328.674v.721a30.2,30.2,0,0,0,3.449,14.04l25.9-44.3Z",
    transform: "translate(-138.031 -154.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M330.333,342.5l-18,26.955a30.576,30.576,0,0,1-5.671-6.153L328.1,340.28Z",
    transform: "translate(-141.69 -171.152)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M278.879,449.376S273.744,434.9,268.1,410.293c-12.432-54.112-27.342-157.22,4.426-263.128a395.649,395.649,0,0,1,35.056-82.259c-4.033-5.653-6.553-8.536-6.553-8.536A394.158,394.158,0,0,0,261,147.165c-31.768,105.908-16.858,209.016-4.426,263.128,5.647,24.6,10.782,39.083,10.782,39.083,20.307,8.751,35.908,10.585,47.357,9.608C304.928,458.24,293.05,455.482,278.879,449.376Z",
    transform: "translate(-115.541 -56.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M966.7,699.386s27.843-34.645,26-69.344A67.343,67.343,0,0,1,1003.74,588.9a113.281,113.281,0,0,1,13.105-16.084",
    transform: "translate(-408.551 -265.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1048.645,532.162c-1.99,4.831.989,22.446.989,22.446s14.517-10.413,16.507-15.244a9.46,9.46,0,0,0-17.5-7.2Z",
    transform: "translate(-441.405 -246.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1006.22,563.48c.959,5.135,13.034,18.3,13.034,18.3s6.553-16.626,5.57-21.766a9.462,9.462,0,0,0-18.6,3.467Z",
    transform: "translate(-424.464 -256.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M974.229,637.677c3.419,3.949,20.492,9.221,20.492,9.221s-2.764-17.65-6.183-21.606a9.458,9.458,0,1,0-14.3,12.386Z",
    transform: "translate(-410.665 -285.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M964.914,702.186c2.7,4.474,18.633,12.551,18.633,12.551s.262-17.871-2.436-22.338a9.462,9.462,0,0,0-16.2,9.787Z",
    transform: "translate(-407.277 -311.669)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1043.174,603.682c-4.849,1.936-22.434-1.221-22.434-1.221s10.556-14.41,15.411-16.352a9.462,9.462,0,0,1,7.023,17.573Z",
    transform: "translate(-430.4 -270.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1031.54,677.512c-5.206.4-21.04-7.875-21.04-7.875s14.38-10.6,19.592-11a9.464,9.464,0,1,1,1.448,18.874Z",
    transform: "translate(-426.26 -299.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1008.71,748.192c-5.069,1.275-22.07-4.206-22.07-4.206s12.384-12.873,17.454-14.142a9.46,9.46,0,1,1,4.617,18.347Z",
    transform: "translate(-416.613 -328.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1048.645,532.162c-1.99,4.831.989,22.446.989,22.446s14.517-10.413,16.507-15.244a9.46,9.46,0,0,0-17.5-7.2Z",
    transform: "translate(-441.405 -246.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1006.22,563.48c.959,5.135,13.034,18.3,13.034,18.3s6.553-16.626,5.57-21.766a9.462,9.462,0,0,0-18.6,3.467Z",
    transform: "translate(-424.464 -256.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M974.229,637.677c3.419,3.949,20.492,9.221,20.492,9.221s-2.764-17.65-6.183-21.606a9.458,9.458,0,1,0-14.3,12.386Z",
    transform: "translate(-410.665 -285.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M964.914,702.186c2.7,4.474,18.633,12.551,18.633,12.551s.262-17.871-2.436-22.338a9.462,9.462,0,0,0-16.2,9.787Z",
    transform: "translate(-407.277 -311.669)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1043.174,603.682c-4.849,1.936-22.434-1.221-22.434-1.221s10.556-14.41,15.411-16.352a9.462,9.462,0,0,1,7.023,17.573Z",
    transform: "translate(-430.4 -270.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1031.54,677.512c-5.206.4-21.04-7.875-21.04-7.875s14.38-10.6,19.592-11a9.464,9.464,0,1,1,1.448,18.874Z",
    transform: "translate(-426.26 -299.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1008.71,748.192c-5.069,1.275-22.07-4.206-22.07-4.206s12.384-12.873,17.454-14.142a9.46,9.46,0,1,1,4.617,18.347Z",
    transform: "translate(-416.613 -328.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M967.12,718.118s39.494-20.4,51.867-52.862a67.313,67.313,0,0,1,26.77-33.138,113.127,113.127,0,0,1,18.466-9.388",
    transform: "translate(-408.721 -285.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1137.861,586.666c-3.777,3.616-8.191,20.927-8.191,20.927s17.489-3.64,21.266-7.25a9.469,9.469,0,0,0-13.075-13.7Z",
    transform: "translate(-474.442 -269.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1090.049,598.132c-1.191,5.087,4.5,22.041,4.5,22.041s12.682-12.551,13.909-17.668a9.46,9.46,0,1,0-18.407-4.372Z",
    transform: "translate(-458.356 -272.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1030.659,652.994c1.525,5,15,16.733,15,16.733s4.628-17.275,3.1-22.249a9.462,9.462,0,0,0-18.1,5.516Z",
    transform: "translate(-434.243 -292.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M996.008,708.2c.655,5.188,11.95,19.026,11.95,19.026s7.482-16.221,6.821-21.409a9.46,9.46,0,0,0-18.77,2.383Z",
    transform: "translate(-420.37 -315.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1105.945,652.465c-5.224-.191-20.015-10.2-20.015-10.2s15.488-8.894,20.712-8.7a9.46,9.46,0,1,1-.7,18.907Z",
    transform: "translate(-456.757 -289.726)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1067.038,715.687c-4.927-1.745-16.048-15.726-16.048-15.726s17.448-3.854,22.368-2.109a9.461,9.461,0,0,1-6.32,17.835Z",
    transform: "translate(-442.63 -315.538)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1016.586,770.88c-5.147-.888-18.466-12.789-18.466-12.789s16.542-6.743,21.689-5.856a9.46,9.46,0,0,1-3.217,18.645Z",
    transform: "translate(-421.254 -337.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M892.388,583.992l-30.612-44.4s-.6-10.99-2.573-13.558-.429-8.28-.429-8.28,2.145-3.139.286-3.425-.286-7.285-.286-7.285l-.143-11.133s1.716-10.722.286-13.272a4.212,4.212,0,0,1,.143-4.569s1.716-6.142,0-7.708-1.287-11.139-.858-18.7-3.008-11.848-3.008-12.992S843.875,426.39,843.875,425.4s-7.148-5.141-11.443-6.285-6.439-2-6.3-2.567-6.725-2.853-6.725-2.853-6.01-.429-8.3-3.431-9.287-3.86-9.489-3.89c-.042-.2-.089-.4-.131-.6s-.089-.429-.131-.643c.542-.911,1.042-1.841,1.5-2.8.137-.292.268-.6.393-.87a12.219,12.219,0,0,0,7.047-2.186,9.6,9.6,0,0,0,3.425-6.844,15,15,0,0,0-1.674-7.607c-1.251-2.573-3.092-5.236-2.46-8.024.28-1.191,1-2.264,1.37-3.443a9.069,9.069,0,0,0-1.031-6.761c-1.084-2.073-2.591-3.9-3.795-5.9a23.052,23.052,0,0,1-3.02-8.34,13.039,13.039,0,0,0-1.12-4.545,8.464,8.464,0,0,0-2.508-2.532,25.061,25.061,0,0,0-15.381-4.664c-3.9.137-7.78,1.191-11.646.709a41.907,41.907,0,0,1-6.8-1.787c-4.8-1.418-10.335-2-14.517.745s-5.844,8.149-8.673,12.372c-2.5,3.741-6.171,6.874-8.078,10.83a.852.852,0,0,1,.06-.226,12.959,12.959,0,0,0-1.066,2.883c-.727,3.109-.119,6.362.637,9.466.387,1.6.923,3.342,2.311,4.229s3.354.691,5,.983c-.06.268-.131.542-.191.816a32.7,32.7,0,0,0,22.69,38.124v.87a21.614,21.614,0,0,1-.149,2.454h0s-14.386-2.978-18.252-.953-11.449,3.574-12.593,4.706-4,.286-6.553,7-2.859,13.558-6.154,16.679-5,5.284-5.147,7.571.429,2.853-.864,3.574-3.145,3.711-2.573,4.855c0,0,.715,2.853-1.573,4.277a4.782,4.782,0,0,0-2.008,4.283s-.858,3.145-2.859,3.854-3.294,5.427-3.294,5.427l-6.511,7.476L682.431,477.59a5.421,5.421,0,0,0-7.655-.393l-6.314,5.695a12.474,12.474,0,0,0-6.32,3.765,16.291,16.291,0,0,0-3.27,4.873l-3.461,3.109a8.787,8.787,0,0,0-.888,9.7l8.238,9.108.054.077a14.551,14.551,0,0,0-7.97,3.247c-12.3,10.848-12.45,20.849-10.585,25.406s17.454,22.13,17.454,22.13,9.06,11.777,22.142,18.043h0l-.1.1c-.256.274-.512.6-.763.894l-.214.274-.2.274-.232.346c-.066.089-.125.185-.185.28s-.167.268-.244.411l-.161.274c-.1.179-.2.363-.292.554l-.1.185c-.119.25-.238.506-.351.774-.042.1-.078.2-.119.292-.072.185-.149.375-.22.6s-.089.244-.131.369-.125.369-.185.56-.083.268-.119.4-.119.417-.173.631-.066.25-.1.387c-.077.328-.155.667-.22,1.025a2.513,2.513,0,0,1-.072.405q-.071.357-.125.733c-.03.173-.048.346-.071.518s-.06.471-.089.709l-.054.548c0,.262-.048.536-.065.81a2.822,2.822,0,0,1-.03.5c0,.453-.048.906-.054,1.382-.286,16.679.691,19.128.691,19.128s2.019,5.319,7.6,5.7a9.712,9.712,0,0,0,2.448-.131c7.44-1.287,24.894-4.283,31.047-3.139,3.7.685,10.55-.328,15.428-1.251l1.281-.244.894,2.835,2.829-.774,2.383,1.388,1.519.87c2.824,9.579,14.3,6.314,14.3,6.314l2.693,1.561,27.616.715s5.957,3.574,9.775,4.694a9.072,9.072,0,0,0,1.388.3,62.665,62.665,0,0,0,7.7.143c2.115-.054,3.753-.143,3.753-.143s-.28-7.5-.685-15.893c10.556-.441,19.914-1.1,25.579-2.1,14.749-2.591,20.9-16,23.166-23.166a67.409,67.409,0,0,1,1.448,8.894,63.6,63.6,0,0,0,2.293,7.708,26.052,26.052,0,0,0,3.145,5.707c10.877-3.711,4.295-9.275,2-11.705s1.578-4.426,1.578-4.426,2.979-2,2.716-3.854-.429-3.854,9.3-3.711S892.388,583.992,892.388,583.992Zm-151.1-91.141c.125.816,1.483,9.614,2.71,11.914a15.728,15.728,0,0,1,.322,4.7c-5.766-.459-11.771-.7-11.771-.7a1.382,1.382,0,0,1,.31.733l-.906-.2-1.316-.322,10.621-16.155Zm-21.04,33.478,9.978,1.585.84.131a32.834,32.834,0,0,0-.518,4.712c0,.149.226.328.548.536a12.857,12.857,0,0,0-.2,2.383c.161.792,4.825,2.5,10.174,3.914-.071.286-.143.56-.214.816h0c-4.724-2.484-12.17-3.646-13.028-5.492s-26.21-10.722-26.21-10.722-.923-.488-2.52-1.263l6.672,1.263,1.835-.185a100.025,100.025,0,0,0,12.641,2.311Z",
    transform: "translate(-277.833 -170.369)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M884.352,724.755s-3.967,23.965-24.108,27.509S772.88,755.1,772.88,755.1s-38.434-5.528-52.331-38.005-22.833-45.386-10.919-45.952,76.159,21.7,79.822,21.981S887.9,643.771,884.352,724.755Z",
    transform: "translate(-302.369 -304.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M884.352,724.755s-3.967,23.965-24.108,27.509S772.88,755.1,772.88,755.1s-38.434-5.528-52.331-38.005-22.833-45.386-10.919-45.952,76.159,21.7,79.822,21.981S887.9,643.771,884.352,724.755Z",
    transform: "translate(-302.369 -304.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M703.568,781.253s2.007,5.29,7.529,5.665a9.786,9.786,0,0,0,2.424-.131c7.375-1.275,24.679-4.253,30.773-3.121,3.669.685,10.454-.328,15.285-1.239,3.217-.6,5.564-1.191,5.564-1.191s-5.671-18.86-6.386-19.425-25.525-15.458-25.525-15.458l-19.658-1.412h-.06a10.333,10.333,0,0,0-6.66,3.914c-2.079,2.508-3.86,6.63-3.979,13.385C702.6,778.841,703.568,781.253,703.568,781.253Z",
    transform: "translate(-301.865 -334.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M703.569,781.265s2.007,5.29,7.53,5.665a80.734,80.734,0,0,1-5.361-7.792l.1-13.755a24.178,24.178,0,0,1,7.744-20.414h-.06s-10.353.7-10.639,17.275S703.569,781.265,703.569,781.265Z",
    transform: "translate(-301.866 -334.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M839.429,726.235l18.294-14.3,28.79-28.367s-3.109-.149-7.8-.352c-1.191.745-4.438,3.086-4.557,5.957-.143,3.467-7.786.238-11.753,2.222s-23.4,26.854-26.806,26.693-6.094-1.728-7.518.685c0,.054-.066.1-.1.155Z",
    transform: "translate(-352.465 -309.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M709.6,748.866c.649.316,1.3.6,1.978.906,13.9,5.957,31.059,18.466,32.34,20.706.774,1.382,10.722,7.422,18.4,11.95,3.217-.6,5.564-1.191,5.564-1.191s-5.671-18.86-6.386-19.425-25.525-15.458-25.525-15.458l-19.658-1.412h-.06A10.378,10.378,0,0,0,709.6,748.866Z",
    transform: "translate(-304.603 -334.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M644.248,663.87c1.841,4.539,17.275,21.987,17.275,21.987s9.781,12.76,23.685,18.717,31.059,18.466,32.334,20.706c.822,1.459,11.914,8.131,19.705,12.718l1.745,1.019,3.872,2.246,2.049,1.191s4.766-3.812,9.477-7.649,9.311-7.595,9.388-7.809c.137-.423,1.978-5.248,1.555-5.528-.22-.149-1.191-2.115-2.979-4.39a20.145,20.145,0,0,0-7.226-5.957c-6.553-2.979-9.358-9.757-9.358-9.757s-.6-.453-1.567-1.048c-1.68-1.06-4.378-2.585-6.374-2.841-3.127-.393-8.935-6.773-8.935-6.773s-3.973-2.556-5.534-5.814c-1.489-3.109-23.482-18.216-25.519-19.61l53.32,34.24,12.76,8.2,18.294-14.3,28.8-28.367s-3.872-.191-9.531-.429c-13.993-.6-38.845-1.555-41.984-.846a23.929,23.929,0,0,1-7.8.506s-7.077.322-11.759-2.15-12.063-3.628-12.915-5.456-25.954-10.633-25.954-10.633S666.89,627.9,654.69,638.678,642.4,659.337,644.248,663.87Z",
    transform: "translate(-277.827 -290.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M829.82,479.992l4.4,14.606,5.671,32.9,20.849,1.418,6.034-10.008,6.046-9.99s3.753-13.3,6.451-26.157c2.383-11.378,3.943-22.422,1.346-23.619-2.3-1.066-3.812-4.9-4.766-9.019-.125-.506-.238-1.025-.346-1.543a80.2,80.2,0,0,1-1.382-10.573s-43.682-2.264-37.582,15.744a28.7,28.7,0,0,1,1.644,9.579,22.777,22.777,0,0,1-.149,2.436,20.432,20.432,0,0,1-8.215,14.225Z",
    transform: "translate(-353.209 -210.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M814.58,496.454l1.561,24.816,3.544,21.129,3.973,9.787,3.544,53.541s34.2,3.955,42.514-.071a3.657,3.657,0,0,0,1.507-1.191c10.043-15.148,6.749-59.086,6.749-59.086l3.83-28.373-2.555-14.725-6.165-.655-4.766-.506s-1.072,1.322-2.621,3.366c-4.206,5.552-11.914,16.471-11.419,21.028.7,6.243-.852,12.623-3.264,13.617s-4.4,2.693-4.819.995-.852-2.127-.429-4.539-1.847-9.787-1.847-9.787-3.824-8.649-3.574-12.337-.423-7.947-1.561-8.935-2.693-1.99-1.418-6.553-5.594-13.373-5.594-13.373Z",
    transform: "translate(-347.047 -229.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M890.369,547.649l1.418,42.407,8.191,4.539a3.663,3.663,0,0,0,1.507-1.191c10.049-15.172,6.755-59.1,6.755-59.1l3.83-28.367-2.555-14.72-6.171-.655c2.383-11.378,3.943-22.422,1.352-23.619-2.305-1.066-3.818-4.9-4.8-9.019h0l-4.408,30.023s.369,2.7.5,5.492a15.75,15.75,0,0,1-.357,5.284c-.995,2.556-.286,7.095-.286,7.095-2.556,4.5-3.83,12.849-4.456,20.909C890.047,537.439,890.369,547.649,890.369,547.649Z",
    transform: "translate(-377.665 -218.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M900.559,456.82s7.148.888,9.412,3.866,8.227,3.389,8.227,3.389,6.809,2.27,6.666,2.836,1.984,1.424,6.243,2.555,11.318,5.248,11.318,6.243,11.2,12.051,11.2,13.189,3.407,5.361,2.978,12.9-.852,17.019.852,18.58,0,7.661,0,7.661a4.17,4.17,0,0,0-.089,4.539c1.418,2.555-.28,13.195-.28,13.195l.137,11.062s-1.561,6.946.286,7.232-.286,3.4-.286,3.4-1.561,5.677.429,8.227,2.55,13.474,2.55,13.474l30.38,44.081s.429,8.083-9.215,7.941-9.531,1.847-9.221,3.687-2.693,3.83-2.693,3.83-3.83,1.984-1.561,4.4,8.792,7.941-1.984,11.628a25.709,25.709,0,0,1-3.121-5.671,64.16,64.16,0,0,1-2.269-7.655s-.995-10.782-2.979-12.2-1.7-8.227-1.7-8.227,2.835-5.528-1.132-7.8S893.1,589.033,893.1,589.033l-1.418-42.407s-.995-31.339,4.962-41.835c0,0-.709-4.539.286-7.089s-.143-10.782-.143-10.782Z",
    transform: "translate(-378.193 -218.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M809.048,484.266s-14.255-2.937-18.085-.953-11.318,3.574-12.509,4.682-3.973.286-6.523,6.952-2.841,13.469-6.1,16.59-4.962,5.248-5.105,7.518.423,2.835-.852,3.574-3.121,3.687-2.555,4.825,29.552,26.061,29.552,26.061,1.424,9.531,2.7,11.914-1.418,35.6-4.253,37.868,19.146,2.061,19.146,2.061.989-21.772,1.841-22.91-.6-24.423-.6-24.423-.143-19.854,1.7-25.1,1.638-22.672,1.638-22.672,1.632-10.466,3.616-12.909S809.048,484.266,809.048,484.266Z",
    transform: "translate(-323.854 -228.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M808.339,483.556s-14.261-2.937-18.091-.953-11.318,3.544-12.48,4.682-3.967.28-6.553,6.946-2.835,13.475-6.1,16.6-4.962,5.248-5.105,7.518.429,2.835-.846,3.544-3.121,3.687-2.555,4.819,29.5,26.1,29.5,26.1,1.418,9.531,2.693,11.914-1.418,35.592-4.253,37.862,19.145,2.061,19.145,2.061.995-21.772,1.847-22.9-.6-24.423-.6-24.423-.137-19.854,1.7-25.1,1.638-22.7,1.638-22.7,1.632-10.466,3.61-12.9S808.339,483.556,808.339,483.556Z",
    transform: "translate(-323.567 -228.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M840.6,453.752a28.7,28.7,0,0,1,1.644,9.579,32.543,32.543,0,0,0,37.32-14.749,80.184,80.184,0,0,1-1.382-10.574S834.51,435.744,840.6,453.752Z",
    transform: "translate(-357.333 -210.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M804.82,404.815a32.477,32.477,0,1,0,.7-6.749A32.477,32.477,0,0,0,804.82,404.815Z",
    transform: "translate(-343.101 -184.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M750.474,553.06l-7.8,2.413s.709,2.835-1.561,4.253a4.746,4.746,0,0,0-1.984,4.259s-.852,3.115-2.836,3.824-3.264,5.361-3.264,5.361l-6.523,7.518s-2.413,1.984-1.984,2.978-2.556,1.275-2.556,1.275l1.561,25.269,13.474,2.556,8.34-.852,6.809-2.556,5.957-3.574,2.716-6.892,11.914-18.151Z",
    transform: "translate(-309.604 -257.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M701.7,599.492S684.42,574.527,671.488,588s5.248,35.313,9.5,34.6,24.536-1.841,24.536-1.841Z",
    transform: "translate(-287.346 -269.694)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 36.587,
    height: 41.579,
    rx: 12.62,
    transform: "translate(372.994 331.872) rotate(-42.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 36.587,
    height: 41.579,
    rx: 12.62,
    transform: "translate(372.994 331.872) rotate(-42.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 36.587,
    height: 41.579,
    rx: 12.62,
    transform: "translate(373.481 329.817) rotate(-42.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 8.084,
    cy: 8.084,
    r: 8.084,
    transform: "translate(392.452 325.944)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.084,
    cy: 8.084,
    r: 8.084,
    transform: "translate(392.452 325.944)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 8.084,
    cy: 8.084,
    r: 8.084,
    transform: "translate(392.905 324.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M706.5,612.808c-.143,18.723,38.577,22.69,38.577,22.69l9.888,1.573,4.432.7,1.847-18.276s-2.031-.3-4.569-.893c-3.747-.876-8.6-2.383-9.62-4.5C745.357,610.562,706.637,594.092,706.5,612.808Z",
    transform: "translate(-303.349 -277.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M806,398.157a3.854,3.854,0,0,1,2.383,1.06c1.1,1.162,1.156,3.223,2.579,3.937a2.931,2.931,0,0,0,1.692.2c3.771-.536,5.957-4.766,9.573-5.957a9.652,9.652,0,0,1,6.344.542,4.724,4.724,0,0,1,2.1,1.352c1.191,1.567.363,3.872.923,5.772.78,2.633,3.926,3.681,6.648,4.027s5.79.536,7.607,2.591a6.9,6.9,0,0,1,1.352,5.486,4.341,4.341,0,0,0,0,2.031c.75,2.127,4.432,1.787,5.391.131.7-1.221.488-2.234,2.144-2.573a7.063,7.063,0,0,1,3.473.6,25.443,25.443,0,0,0,8.983,1.382A32.483,32.483,0,1,0,806,398.157Z",
    transform: "translate(-343.578 -184.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M841.771,406.529a4.343,4.343,0,0,1,0-2.031,6.909,6.909,0,0,0-1.352-5.486c-1.787-2.055-4.885-2.252-7.607-2.591s-5.868-1.388-6.648-4.021c-.56-1.9.286-4.212-.923-5.778a4.646,4.646,0,0,0-2.1-1.346,9.788,9.788,0,0,0-6.35-.548c-3.616,1.191-5.8,5.433-9.573,5.957a2.931,2.931,0,0,1-1.692-.2c-1.424-.715-1.483-2.776-2.579-3.932-1.722-1.823-4.992-.649-7.1-2-1.376-.888-1.906-2.609-2.287-4.2-.751-3.086-1.352-6.32-.631-9.406,1.233-5.278,5.957-8.894,8.935-13.4,2.806-4.2,4.378-9.531,8.6-12.3s9.632-2.15,14.386-.739a44.4,44.4,0,0,0,6.737,1.787c3.836.471,7.684-.6,11.544-.7a24.792,24.792,0,0,1,15.244,4.628,8.435,8.435,0,0,1,2.49,2.52,12.892,12.892,0,0,1,1.1,4.515,23.081,23.081,0,0,0,2.979,8.3c1.191,2,2.687,3.806,3.765,5.868a9,9,0,0,1,1.019,6.713c-.363,1.191-1.084,2.222-1.352,3.419-.631,2.77,1.191,5.415,2.436,7.97a14.951,14.951,0,0,1,1.656,7.559,9.531,9.531,0,0,1-3.4,6.8,12.2,12.2,0,0,1-7.19,2.18,25.484,25.484,0,0,1-9.162-1.376,7.132,7.132,0,0,0-3.473-.6c-1.656.34-1.442,1.352-2.144,2.573C846.2,408.34,842.521,408.656,841.771,406.529Z",
    transform: "translate(-338.163 -172.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M837.09,727.612l18.294-14.3,28.8-28.367s-3.872-.191-9.531-.429a6.154,6.154,0,0,0-2.007,3.872c-.143,3.467-7.786.244-11.753,2.228s-23.4,26.848-26.806,26.687-6.094-1.728-7.518.685a1.475,1.475,0,0,1-.1.161,4.033,4.033,0,0,1-2.162,1.281Z",
    transform: "translate(-350.977 -310.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M783.87,719.923l9.192,29.344,1.442,4.611,4.378-1.191,9.65-2.651,42.985-11.807A37.449,37.449,0,0,0,867,734.1a46.855,46.855,0,0,1,26.711-5.826c5.683.53,12-1.918,17.275-11.6,0,0,11.914-35.146-18.157-45.272s-31.5,5.361-31.5,5.361-.155.083-.405.25c-1.191.745-4.438,3.086-4.557,5.957-.143,3.467-7.786.238-11.753,2.222s-23.4,26.854-26.806,26.693-6.094-1.727-7.518.685c0,.054-.066.1-.1.155-1.048,1.448-4.206,1.787-6.3,1.841-1.138.036-1.966,0-1.966,0l-.268.083-2.228.62Z",
    transform: "translate(-334.631 -303.638)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M787.86,646.966l4.432.7,1.847-18.276s-2.031-.3-4.569-.894C790.243,631.032,788.718,640.9,787.86,646.966Z",
    transform: "translate(-336.244 -287.682)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M904.272,515.7s13.189-3.83,9.924,33.615-27.652,61.1-27.652,61.1-28.081,12.337-40.7,10.353A216.338,216.338,0,0,0,824,618.388a32.043,32.043,0,0,0-12.766-3.4c-7.095-.286-21.981-4.682-22.267-6.1s3.687-22.267,1.984-23.828c0,0,19.854.816,21.844,2.252s4.819.405,6.946,0,8.655-6.082,21.558-1.114c0,0,4.4.423,6.1-.709s4.432-.286,4.432-.286,2.675-.995,3.086-1.591,3.824,0,3.824,0a1.513,1.513,0,0,0,2.133-.995,9.272,9.272,0,0,1,1.984-3.115s3.83-21.558,11.062-29.642c0,0,2.127-1.847,1.561-4.116S887.271,511.158,904.272,515.7Z",
    transform: "translate(-336.687 -241.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M903.711,510.864s13.189-3.83,9.93,33.615S885.954,605.6,885.954,605.6s-28.081,12.337-40.7,10.353-21.838-2.413-21.838-2.413a32,32,0,0,0-12.766-3.4c-7.089-.286-21.981-4.682-22.267-6.1s3.687-22.267,1.99-23.828c0,0,19.854.816,21.838,2.252s4.825.405,6.952,0,8.649-6.076,21.558-1.114c0,0,4.4.423,6.094-.709s4.438-.286,4.438-.286,2.657-.995,3.08-1.561,3.83,0,3.83,0a1.507,1.507,0,0,0,2.127-.989,9.255,9.255,0,0,1,1.984-3.121s3.83-21.558,11.062-29.641c0,0,2.127-1.847,1.561-4.11S886.663,506.325,903.711,510.864Z",
    transform: "translate(-336.448 -239.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M810,746.909l18.729,22.636c.071-.065.119-.113.119-.131.143-.429,1.984-5.248,1.561-5.534s-3.687-7.375-10.21-10.353a19.2,19.2,0,0,1-8.018-7.3Z",
    transform: "translate(-345.196 -335.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M810.16,796.218l2.049,1.191s4.766-3.812,9.477-7.649,9.311-7.6,9.388-7.809c.137-.423,1.978-5.248,1.555-5.528-.22-.149-1.191-2.115-2.978-4.39-12.7-3.574-4.617,5.26-3.538,5.665,0,0-15.488-3.574-16.31,13.29A19.87,19.87,0,0,0,810.16,796.218Z",
    transform: "translate(-345.099 -345.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M826.711,803.367l2.7,1.561,27.4.709s5.873,3.574,9.686,4.658a8.3,8.3,0,0,0,1.376.3,61.533,61.533,0,0,0,7.625.143c2.1-.054,3.723-.143,3.723-.143s-1.3-34.55-2.276-38.124c-.465-1.739-2.758-1.358-5.022-.489a32.881,32.881,0,0,0-4.9,2.484s-11.628,1.126-13.474,2.127-7.089-.6-10.353,0-9.072-3.842-9.072-3.842c-15.887-5.242-6.952,4.539-5.82,4.968,0,0-15.452-3.574-16.3,13.29S826.711,803.367,826.711,803.367Z",
    transform: "translate(-345.989 -345.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M903.141,790.061c.3,7.148,5.867,16.018,9.185,20.706,2.1-.054,3.723-.143,3.723-.143s-1.3-34.55-2.276-38.124c-.465-1.739-2.758-1.358-5.022-.488C906.03,777.134,902.9,784.3,903.141,790.061Z",
    transform: "translate(-382.848 -345.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M903.141,790.061c.3,7.148,5.867,16.018,9.185,20.706,2.1-.054,3.723-.143,3.723-.143s-1.3-34.55-2.276-38.124c-.465-1.739-2.758-1.358-5.022-.488C906.03,777.134,902.9,784.3,903.141,790.061Z",
    transform: "translate(-382.848 -345.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M894.977,791.008c1.882,6.9,1.865,14.636,4.867,19.312a8.283,8.283,0,0,0,1.376.3,61.509,61.509,0,0,0,7.625.143c2.1-.054,3.723-.143,3.723-.143s-1.3-34.55-2.276-38.124c-.465-1.739-2.758-1.358-5.022-.488a32.879,32.879,0,0,0-4.9,2.484S892.57,782.18,894.977,791.008Z",
    transform: "translate(-379.366 -345.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M736.77,686.94s13.594,4.414,25.114,20.093Z",
    transform: "translate(-315.588 -311.31)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(454.415 195.708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M921.854,401.26a2.781,2.781,0,0,1-.083.3,9.61,9.61,0,0,1-.471,1.191A8.894,8.894,0,0,1,921.854,401.26Z",
    transform: "translate(-844.61 -391.514)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.887,387.765a12.786,12.786,0,0,1,1.054-2.865c-.071.244-.149.488-.208.739-.721,3.086-.119,6.32.631,9.406.387,1.59.911,3.312,2.287,4.2,2.115,1.352,5.361.173,7.1,2,1.1,1.162,1.156,3.223,2.585,3.938a2.925,2.925,0,0,0,1.692.2c3.765-.536,5.957-4.766,9.573-5.957a9.619,9.619,0,0,1,6.344.548,4.647,4.647,0,0,1,2.1,1.346c1.191,1.567.363,3.878.923,5.772.78,2.633,3.926,3.681,6.648,4.021s5.79.536,7.607,2.6a6.9,6.9,0,0,1,1.352,5.486,4.42,4.42,0,0,0,0,2.031c.751,2.127,4.432,1.787,5.361.131.7-1.221.494-2.234,2.15-2.573a7.051,7.051,0,0,1,3.467.6,25.483,25.483,0,0,0,9.162,1.376,12.145,12.145,0,0,0,7.19-2.18,8.34,8.34,0,0,0,2.2-2.681,9.019,9.019,0,0,1-3.038,4.813,12.174,12.174,0,0,1-7.19,2.18,25.429,25.429,0,0,1-9.156-1.376,7.133,7.133,0,0,0-3.473-.6c-1.656.34-1.448,1.352-2.144,2.573-.965,1.68-4.64,2-5.4-.131a4.42,4.42,0,0,1,0-2.031,6.883,6.883,0,0,0-1.346-5.486c-1.823-2.055-4.891-2.252-7.613-2.591s-5.867-1.388-6.642-4.021c-.566-1.9.286-4.212-.923-5.778a4.694,4.694,0,0,0-2.1-1.346,9.771,9.771,0,0,0-6.344-.548c-3.622,1.191-5.808,5.433-9.573,5.957a2.924,2.924,0,0,1-1.692-.2c-1.43-.715-1.489-2.776-2.585-3.932-1.722-1.823-4.986-.649-7.095-2-1.382-.888-1.906-2.609-2.293-4.2C792.762,394.086,792.16,390.851,792.887,387.765Z",
    transform: "translate(-792.558 -384.9)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M918.188,575.647c-2.6,3.509-5.564,6.755-7.863,10.466s-3.926,8.042-3.443,12.378c2.383-2.442,3.467-5.814,4.968-8.876,2.538-5.182,6.338-9.579,9.531-14.344.6-.911,4.533-6.165,2.55-6.416C922.3,568.648,919.076,574.45,918.188,575.647Z",
    transform: "translate(-384.332 -263.565)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSup8);
export default __webpack_public_path__ + "static/media/sup8.29d9175f6e026e95331733447db39dc6.svg";
export { ForwardRef as ReactComponent };